import { Button, Card, CardMedia, Grid, Typography } from '@material-ui/core';

import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import PropTypes from 'prop-types';
import React from 'react';
import { Truncate } from '@uml/uml-components';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  proceduresListItem: {
    maxWidth: 361,
    width: '100%',
    position: 'relative',
    height: 'max-content',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    '@media(min-width: 768px)': {
      marginBottom: 0,
      paddingBottom: 50,
    },
  },
  procedureListMedia: {
    paddingTop: '65%',
    marginBottom: theme.spacing(2),
  },
  procedureDetailButton: {
    '@media(min-width: 768px)': {
      position: 'absolute',
      bottom: 16,
      left: 16,
    },
  },
  proceduresListItemTitle: {
    wordBreak: 'break-word',
    marginBottom: theme.spacing(2),
  },
  procedureListDetail: {
    marginBottom: theme.spacing(2),
    fontSize: '1.3em',
  },

  procedureItemDescription: {
    fontSize: '1.2em',
    marginBottom: theme.spacing(2),
  },
}));

const ProcedureListItem = ({ procedure }) => {
  const classes = useStyles();
  return (
    <Card key={procedure.id} className={classes.proceduresListItem}>
      <Grid item xs={12}>
        <CardMedia
          className={classes.procedureListMedia}
          image='/static/images/pp_thumbnail.png'
          title='Contemplative Reptile'
        />
        <Typography variant='h5' className={classes.proceduresListItemTitle}>
          <Truncate
            withShowBtn
            maxCellWidth={44}
            text={procedure?.name ?? ''}
          />
        </Typography>
        <ul className={classes.procedureListDetail}>
          {procedure?.submit_end ? <li>
            <strong>Termin składania wniosków: </strong> {procedure?.submit_end}
          </li> : ''}
          {procedure?.comments_end ? <li>
            <strong>Termin składania uwag: </strong> {procedure?.comments_end}
          </li> : ''}
        </ul>
        <Typography className={classes.procedureItemDescription}>
          <Truncate
            maxCellWidth={130}
            withShowBtn
            text={procedure?.description_short ?? ''}
          />
        </Typography>
      </Grid>
      <div className={classes.procedureDetailButton}>
        <a href={`${previewUrl}?procedureId=${procedure.id}`}>
          <Button
            variant='contained'
            color='primary'
            endIcon={<KeyboardArrowRightIcon />}
          >
            Szczegóły procedury
          </Button>
        </a>
      </div>
    </Card>
  );
};

ProcedureListItem.propTypes = {
  procedure: PropTypes.object,
};

ProcedureListItem.defaultProps = {
  procedure: {},
};

export default ProcedureListItem;
